const formatPermissions = permissions =>
  typeof permissions === "string" ? [permissions] : permissions;

const isRenderable = (currentPermissions, acceptablePermissions) =>
  formatPermissions(currentPermissions)
    .map(permission =>
      formatPermissions(acceptablePermissions).includes(permission)
    )
    .includes(true) ||
  currentPermissions.includes("all") ||
  currentPermissions === "all";

const PermissibleWrapper = ({
  currentPermissions = [],
  acceptablePermissions = [],
  children,
}) => isRenderable(currentPermissions, acceptablePermissions) && children;

export default PermissibleWrapper;
